import useAxios from "axios-hooks";
import { CheckoutInfoResponse } from "../types/CheckoutInfoResponse";
import { CheckoutStatusResult } from "../types/CheckoutStatusResult";
import { CheckoutSubmissionRequest } from "../types/CheckoutSubmissionRequest";
import {CheckoutChannelInfoResponse} from "../types/CheckoutChannelInfoResponse";

export const useGetCheckoutApi = (id: string | number, cid: string | number) => {
  const [{ data, loading, error }, refetch] = useAxios<CheckoutInfoResponse>({
    url: `v2/checkout/${id}?cid=${cid}`
  });

  return { data, loading, error, refetch };
};

export const usePostCheckoutApi = (id: string | number) => {
  const [{ data, loading, error }, executePost] =
    useAxios<CheckoutSubmissionRequest>(
      { url: `v2/checkout/${id}`, method: "POST" },
      { manual: true }
    );

  return { data, loading, error, executePost };
};

export const useGetOrderApi = (id: string | number) => {
  const [{ data, loading, error }, refetch] = useAxios<CheckoutStatusResult>(
    `v2/orders/${id}`,
    {
      manual: true
    }
  );

  return { data, loading, error, refetch };
};

export const usePostCheckoutTypeApi = (id: string | number) => {
  const [{ data, loading, error }, executePost] =
    useAxios<CheckoutSubmissionRequest>(
      { url: `v2/checkout/${id}/send-otp`, method: "POST" },
      { manual: true }
    );

  return { data, loading, error, executePost };
};

export const usePostCheckoutChannelApi = (id: string | number) => {
  const [{ data, loading, error }, executePost] =
    useAxios<CheckoutChannelInfoResponse>(
      { url: `v2/checkout/${id}/fetch-channel`, method: "POST" },
      { manual: true }
    );

  return { data, loading, error, executePost };
};
